// extracted by mini-css-extract-plugin
export default {"heading":"RequestTypeForm_heading__QlR34","subHeading":"RequestTypeForm_subHeading__hzN9U","listItem":"RequestTypeForm_listItem__sYiQi","input":"RequestTypeForm_input__dGzin"};